import {Component} from "@angular/core";

@Component({
    selector: "fui-formation-group-template",
    template: "<ng-content></ng-content>",
    standalone: false
})
export class FUIFormationGroupTemplateComponent {
}
